export const ADD_TASK = 'TASKS/ADD_TASK'
export const TOGGLE_TASK = 'TASKS/TOGGLE_TASK'
